import {useState, useEffect} from 'react';
import ApproveorderActionImpl from '../approveorder/ApproveorderActionImpl';
export default function AccountsApprovalActionImpl(){

    return (
        <>
        <ApproveorderActionImpl/>
        </>
    )
}